var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 676,
    height: 322,
    viewBox: "0 0 676 322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6175",
    "data-name": "Group 6175",
    transform: "translate(2670 12051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    transform: "translate(-1994 -11729) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.063,36.141a55,55,0,0,1,75.874,0L576.466,227.178C612.411,261.421,588.175,322,538.529,322H137.471c-49.645,0-73.882-60.579-37.937-94.822Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 337.9999084472656 35.9630126953125 C 327.679931640625 35.9630126953125 317.8814086914062 39.88327026367188 310.409423828125 47.00161743164062 L 109.8800048828125 238.0385284423828 C 95.42431640625 251.8099365234375 95.4698486328125 269.7041015625 100.3325805664062 281.8583679199219 C 105.1953125 294.0126037597656 117.5050659179688 307.0000305175781 137.4705200195312 307.0000305175781 L 538.5294799804688 307.0000305175781 C 558.4949340820312 307.0000305175781 570.8046875 294.0126037597656 575.6674194335938 281.8583679199219 C 580.5301513671875 269.7041015625 580.57568359375 251.8100280761719 566.1199340820312 238.0386047363281 L 365.5904235839844 47.00161743164062 C 358.1183471679688 39.88327026367188 348.31982421875 35.9630126953125 337.9999084472656 35.9630126953125 M 337.9999084472656 20.96304321289062 C 351.6576538085938 20.96304321289062 365.3153686523438 26.02239990234375 375.9368286132812 36.14111328125 L 576.46630859375 227.1780242919922 C 612.4112548828125 261.4213562011719 588.174560546875 322.0000305175781 538.5294799804688 322.0000305175781 L 137.4705200195312 322.0000305175781 C 87.825439453125 322.0000305175781 63.5887451171875 261.4213562011719 99.5335693359375 227.1780242919922 L 300.06298828125 36.14111328125 C 310.6844482421875 26.02239990234375 324.3421936035156 20.96304321289062 337.9999084472656 20.96304321289062 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.ec2eddf46b5b4e136bbd6aa54dec70c5.svg";
export { ForwardRef as ReactComponent };